import {org} from "boislocal-platform-platform-api-api-js-export";

export type ProductEvidenceDownloadQuery = org.boislocal.platform.f2.product.evidence.domain.query.ProductEvidenceDownloadQueryDTO
import {useAuthenticatedRequest} from "../../../config/useAuthenticatedRequest";
import {useFetchBinary} from "@komune-io/g2";

export type UseProductEvidenceDownloadQuery = (a: ProductEvidenceDownloadQuery) =>  Promise<string | undefined>;

export const useProductEvidenceDownloadQuery = (): UseProductEvidenceDownloadQuery  => {
  const requestProps = useAuthenticatedRequest()
  return useFetchBinary<ProductEvidenceDownloadQuery>("productEvidenceDownload", requestProps)
}